import React, {useState} from "react";
import {
    Header,
    Grid,
    Message,
    Input,
    Form,
    Button,
    Divider,
    List,
    Icon,
    Container,
    Modal,
    Progress
} from "semantic-ui-react";
import '../../../style.css'

function EditPronunciationComponent(
    {
        handleSaveSounds,
        handleChange,
        soundsList,
        handleUpload,
        handleDeleteItem,
        error,
        progress,
        loading,
        editSoundLoading,
        editSoundProgress,
        handleClearData,
        editAssignment,
        assignment
    }
) {
    const [open, setOpen] = useState(false);

    return (
        <>
            <Modal
                onClose={() => setOpen(false)}
                onOpen={() => setOpen(true)}
                open={open}
                trigger={<Button color='black' style={{marginTop: 5}}>
                    <Icon name='warning'/>
                    Clear Data
                </Button>}
            >
                <Modal.Header>Restart</Modal.Header>
                <Modal.Content image>
                    <Modal.Description>
                        <p>
                            You are attempting to clear the data on this page for any of these reasons:<br/><br/>
                            1. You are finished uploading the assignment and want to add a new one.<br/>
                            2. You made a mistake and would like to restart.<br/>
                            3. You have encountered an error on submitting the assignment and would like to start over.<br/>
                            4. If you are editing an assignment and would like to start from scratch.<br/><br/>
                            <b>Are you are you want to clear the data on this page?</b>

                        </p>
                    </Modal.Description>
                </Modal.Content>
                <Modal.Actions>
                    <Button color='red' onClick={() => {
                        setOpen(false);
                        handleClearData();
                    }}>
                        Yes
                    </Button>
                    <Button
                        content="No"
                        onClick={() => setOpen(false)}
                    />
                </Modal.Actions>
            </Modal>
            <Grid centered={true}>
                {
                    editAssignment ?
                        <Grid.Row>
                            <Header as='h1'>
                                You are editing {assignment} in Pronunciation
                            </Header>
                        </Grid.Row>
                        :
                        <Grid.Row>
                            <Header as='h1' style={{color: 'black'}}>
                                Add Pronunciation Assignment
                            </Header>
                        </Grid.Row>
                }

                <Message color='blue'>
                    <Header as='h2' textAlign='left' color='black'>
                        <h2 style={{color: 'black'}}>
                            Directions:
                        </h2>
                    </Header>
                    <p style={{textAlign: 'left', color: "black"}}>
                        Use the input "Choose Files" below to select the audio files to be used in the assignment, then
                        click the button "Choose Sound Files"<br/>
                        Once all the audio files are listed in the section "Chosen Sound Files", click the button "Build
                        Assignment"<br/><br/>
                        Once the sounds have finished uploading, you will need to label the audio buttons.<br/>
                        This label will show up as the button name on the pronunciation page<br/>
                    </p>
                </Message>

                <Grid.Row>
                    {
                        editSoundLoading ?
                            <Grid.Row>
                                <Progress percent={editSoundProgress} indicating progress style={{width: 300}}/>
                            </Grid.Row>
                            :
                            null

                    }
                </Grid.Row>
                <Grid.Row columns={4}>
                    <Grid.Column textAlign='center'>
                        <br/>
                        <Form>
                            <input type='file' name='file' id='file' multiple width={1} onChange={handleChange}/>
                            <br/>
                            <br/>
                            <Button onClick={handleSaveSounds} color='blue'>Choose Sound Files</Button>
                        </Form>
                        <Header as='h3'> Note: You may select multiple files at once</Header>
                    </Grid.Column>
                    <Grid.Column>
                        <Header as='h3'>
                            Chosen Sound Files:
                            <Message>
                                <List style={{marginTop: 10}}>
                                    {soundsList.map((item, index) => (
                                        <List.Item id={index} key={index}>
                                            {index + 1}.
                                            {'\xa0\xa0' + item.name}
                                            <Button id={index} onClick={() => handleDeleteItem(index)} color='red' icon><Icon
                                                name='delete'/></Button>
                                        </List.Item>
                                    ))}
                                </List>
                            </Message>
                        </Header>
                    </Grid.Column>
                </Grid.Row>
                <Divider/>
                {
                    error ?
                        <Grid.Row>
                            <Message negative>
                                <Message.Header>{error}</Message.Header>
                            </Message>
                        </Grid.Row>
                        :
                        null
                }
                {
                    loading ?
                        <>
                            <Grid.Row>
                                <Progress percent={progress} indicating progress style={{width: 300}}/>
                            </Grid.Row>
                            <Grid.Row>
                                <Button onClick={handleUpload} disabled color='green'>Add Labels</Button>
                            </Grid.Row>

                        </>
                        :

                        soundsList.length >= 1 ?
                            !editSoundLoading ?
                                <Grid.Row>
                                    <Button onClick={handleUpload} color='blue'>Add Labels</Button>
                                </Grid.Row>
                                :
                                <Grid.Row>
                                    <Button onClick={handleUpload} disabled color='blue'>Add Labels</Button>
                                </Grid.Row>
                            :
                            <Grid.Row>
                                <Button onClick={handleUpload} disabled color='blue'>Add Labels</Button>
                            </Grid.Row>


                }

            </Grid>
        </>
    )
}

export default EditPronunciationComponent
